import React from 'react'
import ReactDOM from 'react-dom'
import template from './template.html'

function directive($ngRedux, $compile, $rootScope) {
  return {
    restrict: 'AE',
    replace: false,
    template,
    link: function (scope, el) {
      const draftReactAppRootEl = el.find('#draftReact')[0]
      const angularGuts = {
        $compile,
        scope,
        $rootScope,
      }

      import(/* webpackChunkName: 'App' */ '~/reactapp/App/App').then(
        ({ default: DraftEditorApp }) => {
          ReactDOM.render(
            <DraftEditorApp store={$ngRedux} angular={angularGuts} />,
            draftReactAppRootEl
          )
          scope.$on('$destroy', () =>
            ReactDOM.unmountComponentAtNode(draftReactAppRootEl)
          )
        }
      )
    },
    controller: 'StoryController',
  }
}

export default ['$ngRedux', '$compile', '$rootScope', directive]
